export const reactionStates = {
  ON: null,
  OFF: 'reactions-off'
}

export const reactionList = [{
  id: '👍',
  intensity: 0,
  volume: 0.8,
  sound: 'yes'
}, {
  id: '👎',
  intensity: 0,
  volume: 0.8,
  sound: 'no'
}, {
  id: '🥂',
  intensity: 1,
  volume: 1,
  sound: 'clink'
}, {
  id: '👏',
  intensity: 0,
  volume: 1,
  sound: 'applause'
}, {
  id: '✨',
  intensity: 1,
  volume: 0.5,
  sound: 'twinkle'
}, {
  id: '🦢',
  intensity: 1,
  volume: 1,
  sound: 'goose'
}, {
  id: '🐮',
  intensity: 2,
  volume: 1,
  sound: 'cow'
}, {
  id: '💾🎉',
  intensity: 1,
  volume: 1,
  sound: 'windows-victory'
}, {
  id: '❌⏲',
  intensity: 2,
  volume: 1,
  sound: 'buzzer'
}, {
  id: '💿❕',
  intensity: 2,
  volume: 1,
  sound: 'record-scratch'
}, {
  id: '😍🤩',
  intensity: 0,
  volume: 1,
  sound: 'anime-wow'
}, {
  id: '🐬🐬',
  intensity: 0,
  volume: 0.8,
  sound: 'dolphin'
}, {
  id: '🐴🐴',
  intensity: 2,
  volume: 1,
  sound: 'horse'
}, {
  id: '😱🤠',
  intensity: 2,
  volume: 1,
  sound: 'wilhelm-scream'
}, {
  id: '🏃‍♀️💰',
  intensity: 2,
  volume: 1,
  sound: 'power-up'
}, {
  id: '😮😮',
  intensity: 0,
  volume: 0.8,
  sound: 'oooh'
}, {
  id: '😢🎺',
  intensity: 0,
  volume: 0.8,
  sound: 'sad-trombone'
}, {
  id: '🤡📯',
  intensity: 0,
  volume: 0.8,
  sound: 'clown-horn'
}, {
  id: '👏👏👏',
  intensity: 0,
  volume: 0.8,
  sound: 'applause-more'
}, {
  id: '😂🤣😂',
  intensity: 2,
  volume: 1,
  sound: 'laugh-track'
}, {
  id: '🐈👎👎',
  intensity: 2,
  volume: 1,
  sound: 'nonono-cat'
}, {
  id: '🍖📯📯',
  intensity: 2,
  volume: 1,
  sound: 'ham-horn-multi'
}, {
  id: '🎷😏🎷',
  intensity: 2,
  volume: 1,
  sound: 'sexy-sax'
}, {
  id: '🤔🎶🎶',
  intensity: 2,
  volume: 1,
  sound: 'final-jeopardy'
}, {
  id: '🚫👉🔥',
  intensity: 2,
  volume: 1,
  sound: 'mc-hammer'
}, {
  id: '🌘👤😢',
  intensity: 2,
  volume: 1,
  sound: 'hello-darkness'
}]

export const audioSprite = {
  'anime-wow': [
    0,
    4200
  ],
  'applause-more': [
    6000,
    7680
  ],
  'awww': [
    15000,
    1384.489795918366
  ],
  'clink': [
    18000,
    1697.9591836734685
  ],
  'clown-horn': [
    21000,
    2115.9183673469392
  ],
  'cow': [
    25000,
    1619.5918367346956
  ],
  'dolphin': [
    28000,
    3343.673469387756
  ],
  'goose': [
    33000,
    287.34693877551365
  ],
  'final-jeopardy': [
    35000,
    7392.653061224493
  ],
  'hello-darkness': [
    44000,
    4257.959183673471
  ],
  'horse': [
    50000,
    2037.5510204081663
  ],
  'laugh-track': [
    54000,
    5746.938775510202
  ],
  'mc-hammer': [
    61000,
    4440.816326530608
  ],
  'nonono-cat': [
    67000,
    3735.5102040816346
  ],
  'no': [
    72000,
    368.6167800453575
  ],
  'oooh': [
    74000,
    2037.5510204081593
  ],
  'power-up': [
    78000,
    1071.020408163264
  ],
  'ham-horn-multi': [
    81000,
    2847.346938775516
  ],
  'record-scratch': [
    85000,
    940.4081632653032
  ],
  'sad-trombone': [
    87000,
    4153.469387755109
  ],
  'sexy-sax': [
    93000,
    6687.346938775505
  ],
  'ham-horn': [
    101000,
    1933.0612244897907
  ],
  'applause': [
    104000,
    3683.2653061224505
  ],
  'twinkle': [
    109000,
    3291.4285714285684
  ],
  'buzzer': [
    114000,
    1175.5102040816325
  ],
  'wilhelm-scream': [
    117000,
    1011.0657596371908
  ],
  'windows-error': [
    120000,
    992.6530612244875
  ],
  'windows-victory': [
    122000,
    1404.807256235827
  ],
  'yes': [
    125000,
    716.0544217687033
  ]
}
